import React, { useState, useEffect } from 'react';
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Image,
  Modal,
  Row
} from 'react-bootstrap';
import {
  useNavigate
} from "react-router-dom";
import _ from "lodash";
import { 
  HiDotsCircleHorizontal,
  HiOutlineChevronLeft,
  HiPlusCircle
} from "react-icons/hi";
import { 
  BsCardHeading,
  BsChatText,
  BsPeople
} from "react-icons/bs";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import { 
  AiOutlineMail
} from "react-icons/ai";

import useUser from '../../hooks/useUser';
import useToken from '../../hooks/useToken';
import FileUpload from '../../components/FileUpload';
import CustomerForm from '../../components/CustomerForm';
import PreviewForm from '../../components/PreviewForm';
import PreviewEmail from '../../components/PreviewEmail';
import storeCustomerAction from '../../actions/storeCustomerAction';
import uploadCustomerCsvAction from '../../actions/uploadCustomerCsvAction';

export default function Dashboard() {
  const { user } = useUser();
  const { token } = useToken();
  const navigate = useNavigate();

// State
  // Alert states
  const [showSaveCustomerConfirm, setShowSaveCustomerConfirm] = useState(false);
  const [showSaveCsvConfirm, setShowSaveCsvConfirm] = useState(false);

  // Modal states
  const [showPreviewEmails, setShowPreviewEmails] = useState(false);
  const [showPreviewForm, setShowPreviewForm] = useState(false);

  // add user form
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();

  const handleChange = (name, value) => {
    const setState = eval('set'+_.upperFirst(name));
    setState(value)
  };

  const storeCustomer = async (args) => {
    const response = await storeCustomerAction(token, args);

    if(response.success) {
      setShowSaveCustomerConfirm(true);
      window.scrollTo(0,0);
    } else {
      alert('Could not save customer.');
    }    
  }

  const uploadCsv = async (args) => {
    const response = await uploadCustomerCsvAction(token, args);

    if(response.success) {
      setShowSaveCsvConfirm(true);
      window.scrollTo(0,0);
    } else {
      alert('Could not save customer.');
    }    
  }  

  return (
    <>
      <Container className="content-body g-0 text-start">
        <Row>
          <Col xs={12} sm={8} md={4} className="px-3 py-3">
            <Card>
              <Card.Header>Emails <AiOutlineMail className="icon float-end" /></Card.Header>
              <Card.Body>
                <Card.Text>
                  View and edit the emails sent to your customers
                </Card.Text>
                <Button onClick={()=>setShowPreviewEmails(true)} variant="link">
                  Preview Emails
                </Button>
                <Button onClick={() => navigate("/merchant/settings/emails")} variant="primary" className="float-end">
                  Manage Emails
                </Button>
              </Card.Body>
            </Card>
            <Modal size="lg" show={showPreviewEmails} onHide={()=>setShowPreviewEmails(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Email Preview</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PreviewEmail 
                  settings={user.shop.data}
                />
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={()=>setShowPreviewEmails(false)}>
                  Close Preview
                </Button>
              </Modal.Footer>
            </Modal>
          </Col>
          <Col xs={12} sm={8} md={4} className="px-3 py-3">
            <Card>
              <Card.Header>Feedback Form <BsCardHeading className="icon float-end" /></Card.Header>
              <Card.Body>
                <Card.Text>
                  View and customize the form your customers use to submit reviews
                </Card.Text>
                <Button onClick={()=>setShowPreviewForm(true)} variant="link">
                  Preview Form
                </Button>                
                <Button onClick={() => navigate("/merchant/settings/form")} variant="primary" className="float-end">
                  Manage Form
                </Button>                
              </Card.Body>
            </Card>     
            <Modal size="lg" show={showPreviewForm} onHide={()=>setShowPreviewForm(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Review Form Preview</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PreviewForm 
                  settings={user.shop.data}
                />
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={()=>setShowPreviewForm(false)}>
                  Close Preview
                </Button>
              </Modal.Footer>
            </Modal>
          </Col>
          <Col xs={12} sm={8} md={4} className="px-3 py-3">
            <Card>
              <Card.Header>Customer Reviews <BsChatText className="icon float-end" /></Card.Header>
              <Card.Body>
                <Card.Text>
                  View your reviews. Copy the HTML code to embed them in your website
                </Card.Text>
                <Button onClick={() => navigate("/merchant/settings/reviews")} variant="primary">
                  Manage Reviews
                </Button>
              </Card.Body>
            </Card>          
          </Col>
        </Row>
        <Row>
          <Col className="px-3 py-3">
            <Card>
              <Card.Header>Customers <BsPeople className="icon float-end" /></Card.Header>
              <Card.Body>
              <Row>
                <Col xs={12} sm={6} className="mb-3 px-sm-5">           
                  <Card.Title>Upload CSV file</Card.Title>
                  <Card.Text>
                    Export a CSV file from your shop management software. It must include headers in the first row (first_name, last_name, email, phone)
                  </Card.Text>

                  { showSaveCsvConfirm && 
                    <Alert severity="success" className="alert">
                      <AlertTitle>Customer upload saved.</AlertTitle>
                    </Alert>
                  }

                  <FileUpload 
                    uploadCsv={uploadCsv} 
                  />
                </Col>
                <Col xs={12} sm={6} className="mb-3 px-sm-5">
                  <Card.Title>Add Customer</Card.Title>
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Add a customer manually</Accordion.Header>
                      <Accordion.Body>
                        
                        { showSaveCustomerConfirm && 
                          <Alert severity="success" className="alert">
                            <AlertTitle>Customer saved.</AlertTitle>
                          </Alert>
                        }                      

                        <CustomerForm 
                          handleChange={handleChange} 
                        />                        
                        <div className="d-grid d-flex justify-content-end pe-2">
                  <Button onClick={() => storeCustomer({
                    firstName,
                    lastName,
                    email,
                    phone
                  })} variant="primary">
                    Add Customer
                  </Button>                          
                        </div>      
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Col>
             </Row>
              </Card.Body>
            </Card>          
          </Col>
        </Row>
        <Row>
          <Col />
          <Col xs={12} sm={8} md={6} className="px-3 py-3">
            <Card className="text-center">
              <Card.Body>
                <Card.Title>Customize Everything</Card.Title>
                <Card.Text>
                  Send from your own email, host the feedback form on your own domain, send requests over SMS, and more. No additional cost. Setup takes about 1 business day. Contact us for setup.
                </Card.Text>
                <Button onClick={() => navigate("/merchant/settings/customize")} variant="primary">
                  Start Customizing
                </Button>                
              </Card.Body>
            </Card>    
          </Col>
          <Col />
        </Row>


      </Container>
        
      <Container className="mt-auto footer-toolbar fixed-bottom">
        <Row>
          <Col/>
        </Row>
      </Container>
    </>
  )
}